import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1;

const PasswordIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 18;

	if (size) {
		height = size;
	}

	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 18 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.0053 9.01422C15.7666 8.7623 15.4769 8.63644 15.1359 8.63644H14.727V6.04539C14.727 4.39011 14.1647 2.96884 13.0396 1.78133C11.9147 0.593777 10.5683 0 8.99994 0C7.43161 0 6.085 0.593777 4.96013 1.78128C3.83508 2.96884 3.27274 4.39006 3.27274 6.04539V8.63644H2.8637C2.52291 8.63644 2.23307 8.7623 1.99442 9.01422C1.75576 9.26595 1.63647 9.57189 1.63647 9.93194V17.7046C1.63647 18.0643 1.7558 18.3703 1.99442 18.6223C2.23307 18.874 2.52291 19 2.8637 19H15.1362C15.4772 19 15.7669 18.8741 16.0056 18.6223C16.244 18.3703 16.3635 18.0643 16.3635 17.7046V9.9318C16.3637 9.57203 16.244 9.26614 16.0053 9.01422ZM12.2726 8.63644H5.72729V6.04539C5.72729 5.09184 6.04694 4.27762 6.68613 3.60302C7.3254 2.92833 8.09663 2.59106 9.00008 2.59106C9.90362 2.59106 10.6747 2.92828 11.314 3.60302C11.953 4.27757 12.2726 5.09184 12.2726 6.04539V8.63644Z"
				fill={color}
			/>
		</svg>
	);
};

export default PasswordIcon;
